<template>
  <div id="app">
    <canvas id="planet-chart"></canvas>
  </div>
</template>
<script>
import Chart from "chart.js";
import dataFly from "../data/DATA_OK.json";

export default {
  name: "App",
  dataFly: dataFly,
  dataToGraph: [],
  termesDGAC: {
    dessertes: "Nombre total de dessertes",
    dessertes_reg: "Nombre de dessertes régulières",
    dessertes_non_reg: "Nombre de dessertes non régulières",
    pax_total:
      "Nombre total de passagers locaux + en transit des vols commerciaux (sans double compte)",
    pax_reg: "Nombre total de passagers d'un vol régulier",
    pax_non_reg: "Nombre total de passagers d'un vol non régulier",
    fret_total: "Poids total estimé de marchandises d'un vol",
  },
  selectedYear: null,
  yearsDGAF: ["1999", "2004", "2009", "2014", "2019"],
  props: {
    selected: {
      type: String,
    },
    out: {
      type: Array,
    },
    in: {
      type: Array,
    },
  },
  dataInOut: null,
  barChartData: null,
  data() {
    return {
      dataIn: null,
      dataOut: null,
};
  },
  created() {
    this.airport = this.$props.selected;
  },
  mounted() {
    this.out = this.$props.out;
    this.in = this.$props.in;
    this.getDataInOut(this.in, this.out);
    this.barChartData = {
      type: "bar",
      data: {
        labels: ["Entrants", "Sortants"],
        datasets: [
          {
            label: ["Dessertes"],
            data: [
              this.dataInOut.dataIn.dessertes,
              this.dataInOut.dataOut.dessertes,
            ],
            backgroundColor: ["#7FDBFF", "#7FDBFF"],
            borderColor: ["#7FDBFF", "#7FDBFF"],
          },
          {
            label: ["Passagers d'un vol régulier"],
            data: [
              this.dataInOut.dataIn.pax_reg,
              this.dataInOut.dataOut.pax_reg,
            ],
            backgroundColor: ["#FFDC00", "#FFDC00"],
            borderColor: ["#FFDC00", "#FFDC00"],
          },
          {
            label: ["Passagers d'un vol non régulier"],
            data: [
              this.dataInOut.dataIn.pax_non_reg,
              this.dataInOut.dataOut.pax_non_reg,
            ],
            backgroundColor: ["#FF4136", "#FF4136"],
            borderColor: ["#FF4136", "#FF4136"],
          },
        ],
      },
        options: {
          legend: {
            labels: {
                fontColor: 'white'
            }},
          responsive: true,
          lineTension: 1,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  padding: 25,
                  fontColor: 'white'
                },
              },
            ],
            xAxes: [
              {
                ticks: {
                  fontColor: 'white'
                },
              },
            ],
          },
        },
    };
    this.createChart("planet-chart", this.barChartData);
  },
  methods: {
    createChart(chartId, chartData) {
      const ctx = document.getElementById(chartId);
      new Chart(ctx, {
        type: chartData.type,
        data: chartData.data,
        options: chartData.options,
      });
    },
    getDataInOut(dataIn, dataOut) {
      let data = {};
      let dataInc = {};
      let dataOuter = {};
      if (dataIn && dataOut) {
        for (let i in dataIn[0]) {
          let n = dataIn.reduce((accumulator, next) => {
            return accumulator + next[i];
          }, 0);
          dataInc[i] = n;
        }
        for (let j in dataOut[0]) {
          let n = dataOut.reduce((accumulator, next) => {
            return accumulator + next[j];
          }, 0);
          dataOuter[j] = n;
        }
      } else if (dataIn) {
        for (let k in dataIn[0]) {
          let n = dataIn.reduce((accumulator, next) => {
            return accumulator + next[k];
          }, 0);
          dataInc[k] = n;
        }
      } else if (dataOut) {
        for (let l in dataIn[0]) {
          let n = dataIn.reduce((accumulator, next) => {
            return accumulator + next[l];
          }, 0);
          dataOuter[l] = n;
        }
      }
      data.dataIn = dataInc;
      data.dataOut = dataOuter;
      this.dataInOut = data;
    },
  },
};
</script>
<style>
#planet-chart {
  right: 0%;
  width: 20vw;
  display: flex;
  z-index: 1;
  font-family: "Open Sans", sans-serif;
}
.subtitle2{
  color:white;
}
</style>
